import { Box, Typography } from "@mui/material";
import React from "react";

import { icons } from "../../constants";

const DropdownItem = ({
  title,
  goals,
  funds,
  onClick,
  fullRsp,
  containerStyle,
  testId,
}) => {
  return (
    <Box
      sx={{ margin: "16px 16px 0", ...(containerStyle || {}) }}
      data-cy={testId}
    >
      <Typography
        color="secondary"
        sx={{
          fontSize: "20px",
          fontWeight: "700",
          lineHeight: 1.4,
          marginBottom: "16px",
        }}
      >
        {title}
      </Typography>
      {fullRsp && (
        <div>
          <Typography
            color="secondary"
            sx={{ marginTop: "-8px", paddingBottom: "8px" }}
          >
            {`No ${
              fullRsp && goals ? "goal" : "fund"
            } is available for Auto Cash In.`}
          </Typography>
        </div>
      )}

      {goals &&
        goals.map((item, index) => {
          return (
            <div
              key={index}
              onClick={() => onClick(item)}
              data-cy={`dashboard-dropdown-goal-${item.planAlias}`}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "16px 0px 14px",
                }}
              >
                <Typography
                  color={fullRsp ? "primary" : "textPrimary"}
                  sx={{ fontWeight: "700", letterSpacing: "0.32px" }}
                >
                  {item.planAlias}
                </Typography>
                <img src={icons.arrowRight} alt="arrowRight" />
              </Box>
            </div>
          );
        })}
      {funds &&
        funds.map((item, index) => (
          <div
            key={index}
            onClick={() => onClick(item)}
            data-cy={`dashboard-dropdown-fund-${item?.fund?.name}`}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "16px 0px 14px",
              }}
            >
              <Typography
                color={fullRsp ? "primary" : "textPrimary"}
                sx={{ fontWeight: "700", letterSpacing: "0.32px" }}
              >
                {item?.fund?.name || item?.name}
              </Typography>
              <img src={icons.arrowRight} alt="arrowRight" />
            </Box>
          </div>
        ))}
    </Box>
  );
};

export default DropdownItem;
